<template>
  <CollapseItems
    title-class-header="h6"
    title-weight-header="bold"
  >
    <template #title>
      <h5
        v-if="block.trail"
        class="font-weight-black"
      >
        {{ block.trail.acronym }} | {{ block.name }}
      </h5>
    </template>
    <template #content>
      <Timeline :modules="studyingThemes.filter(t => t.block_id == block.id)" />
    </template>
  </CollapseItems>
</template>
<script>

import CollapseItems from "@/common/components/CollapseItems.vue";
import Timeline from "./Timeline.vue";
import { mapGetters } from 'vuex';


export default {
  components: {  CollapseItems, Timeline },
  props: {
    block: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['studyingThemes']),
  },
}
</script>


